import React, { useEffect, useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { getCurrentAdmin, logout } from "../../utils/api";
import LoadingOverlay from "../../components/LoadingOverlay";
import dicomLogo from "../../images/recOrbDicom_icon.png";
import recOrbLogo from "../../images/recOrb_icon.png";

const AdminLayout: React.FC = () => {
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [role, setRole] = useState<"SUPER" | "SUB" | undefined>(undefined);

  useEffect(() => {
    (async () => {
      try {
        const me = await getCurrentAdmin();
        setRole(me.role);
      } catch {}
    })();
  }, []);
  return (
    <div className="flex min-h-screen bg-white w-full">
      {/* Sidebar */}
      <aside className="w-52 border-r border-gray-200 p-4 box-border bg-white flex flex-col justify-between h-screen">
        <div>
          <div className="flex justify-center pb-4">
            <img src="/logo/logo.svg" alt="Takagi" className="w-36" />
          </div>
          <nav className="flex flex-col gap-2 mt-4">
            <NavLink
              to="/admin"
              end
              className={({ isActive }) =>
                [
                  "rounded-md px-3 py-2 no-underline text-left h-[45px] flex items-center gap-[10px]",
                  isActive
                    ? "bg-[#0077C8] text-white active-link"
                    : "text-gray-800 hover:bg-gray-200",
                ].join(" ")
              }
            >
              <img src={recOrbLogo} alt="recOrbLogo" className="h-[22px]" />
              アプリ管理
            </NavLink>
            <NavLink
              to="/admin/license-management"
              end
              className={({ isActive }) =>
                [
                  "rounded-md px-3 py-2 no-underline text-left h-[45px] flex items-center gap-[10px]",
                  isActive
                    ? "bg-[#0077C8] text-white active-link"
                    : "text-gray-800 hover:bg-gray-200",
                ].join(" ")
              }
            >
              <img src={dicomLogo} alt="dicomLogo" className="h-[22px]" />
              RecOrb DICOM
            </NavLink>
            {role === "SUPER" && (
              <NavLink
                to="/admin/accounts"
                className={({ isActive }) =>
                  [
                    "rounded-md px-3 py-2 no-underline text-left",
                    isActive
                      ? "bg-[#0077C8] text-white active-link"
                      : "text-gray-800 hover:bg-gray-200",
                  ].join(" ")
                }
              >
                アカウント管理
              </NavLink>
            )}
          </nav>
        </div>

        {/* Bottom actions */}
        <div className="pt-4">
          <NavLink
            to="/admin/account-edit"
            title="ログイン情報変更"
            aria-label="ログイン情報変更"
            className={({ isActive }) =>
              [
                "mb-2 w-full flex items-center justify-center rounded-md border border-gray-300 bg-white p-2 no-underline",
                isActive
                  ? "bg-[#0077C8] text-[#0077C8] border-[#0077C8]"
                  : "text-gray-700 hover:bg-gray-100",
              ].join(" ")
            }
          >
            {/* Edit Account icon (inline SVG) */}
            ログイン情報変更
          </NavLink>
          <button
            onClick={() => setConfirmOpen(true)}
            title="ログアウト"
            aria-label="ログアウト"
            className="w-full flex items-center justify-center rounded-md border border-gray-300 bg-white p-2 text-gray-700 hover:bg-gray-100"
          >
            {/* Logout icon (inline SVG) */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="w-6 h-6"
            >
              <path d="M16 17l5-5-5-5v3H9v4h7v3z" />
              <path d="M14 3H6c-1.1 0-2 .9-2 2v14a2 2 0 002 2h8a2 2 0 002-2v-2h-2v2H6V5h8v2h2V5a2 2 0 00-2-2z" />
            </svg>
          </button>
        </div>
      </aside>

      {/* Main content */}
      <section className="flex-1 p-5 box-border">
        <Outlet />
      </section>

      {/* Confirm Logout Modal */}
      {confirmOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          {/* Backdrop */}
          <div
            className="absolute inset-0 bg-black/50"
            onClick={() => setConfirmOpen(false)}
            aria-hidden="true"
          />
          {/* Dialog */}
          <div
            className="relative z-10 w-[90%] max-w-md rounded-lg bg-white p-6 shadow-xl"
            role="dialog"
            aria-modal="true"
          >
            <h2 className="text-xl font-semibold mb-3">ログアウトを確認</h2>
            <p className="text-gray-700 mb-6">
              ログアウトしてもよろしいでしょうか。
            </p>
            <div className="flex items-center justify-end gap-3">
              <button
                type="button"
                onClick={() => setConfirmOpen(false)}
                className="px-4 py-2 rounded border border-gray-300 text-gray-700 hover:bg-gray-50"
              >
                キャンセル
              </button>
              <button
                type="button"
                onClick={() => {
                  logout();
                  setConfirmOpen(false);
                }}
                className="px-4 py-2 rounded bg-blue-600 text-white hover:bg-blue-700"
              >
                ログアウト
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Global loading overlay for admin area */}
      <LoadingOverlay />
    </div>
  );
};

export default AdminLayout;
